import { Card, Typography } from "antd";
import React from "react";

const { Text, Title } = Typography;

interface Props {
  semester: string;
}

/**
 * Shown instead of the booking steps when the season's booking window has passed but the season is still running.
 */
const BookingClosed: React.FC<Props> = ({ semester }) => {
  return (
    <Card style={{ width: "100%", textAlign: "center", margin: "20px 0" }}>
      <Title level={4}>Bookingperioden for {semester} er over</Title>
      <Text>
        Det er ikke lenger mulig å booke bedriftspresentasjon her. Ønsker dere å booke en dato, send en e-post til{" "}
        <a href="mailto:bedrift@bindeleddet.no">bedrift@bindeleddet.no</a>, så finner vi en løsning sammen.
      </Text>
    </Card>
  );
};

export default BookingClosed;
